export function hexToNumber(hex: string): number {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const fullHex = hex.replace(
    shorthandRegex,
    (_m: string, r: string, g: string, b: string): string => {
      return r + r + g + g + b + b;
    },
  );

  return Number.parseInt(fullHex.replace('#', ''), 16);
}
